import { Chip } from '@mui/material';
import { IDataProdutosPedidos } from '../../../../../../../../types/api/comercial/pedidos-pesquisar-produtos';

export interface EstoqueChipsProps {
    produto: IDataProdutosPedidos;
    publico_fazendeiro: boolean;
}

export function EstoqueChips({ produto, publico_fazendeiro }: EstoqueChipsProps) {
    return (
        <>
            {!(produto.estoque[0]?.emite_receita === "S" && !publico_fazendeiro) && (
                <Chip
                    label={produto.estoque_total > 0 ? `Estoque: ${produto.estoque_total}` : "Estoque indisponível"}
                    size="small"
                    sx={{
                        height: '20px',
                        fontSize: '0.75rem',
                        mt: 0.5,
                        backgroundColor: produto.estoque_total > 0 ? '#E8F5E9' : '#FFEBEE',
                        color: produto.estoque_total > 0 ? '#2E7D32' : '#C62828'
                    }}
                />
            )}
            {(produto.estoque[0]?.emite_receita === "S" && !publico_fazendeiro) && (
                <Chip
                    label={
                        <span style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            display: "block"
                        }}>
                            Somente produtores rurais
                        </span>
                    }
                    size="small"
                    sx={{
                        maxWidth: 200,
                        minWidth: 0,
                        height: 'auto',
                        color: "#663c00",
                        backgroundColor: "#fff4e5",
                        fontSize: '0.75rem',
                        mt: 0.5,
                    }}
                />
            )}
        </>
    );
}